import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { authSlice } from '../../Authentication/AuthApi.ts';
import { classesApi } from '../../Settings/Classes/ClassesApi.ts';


import { studentsApi } from '../../Enrollment/Students/StudentsApi';
import { staffsApi } from '../../Enrollment/Staff/StaffsApi';
import { userAccountsApi } from '../../Settings/UserAccounts/UserAccountsApi';
import { AcademicYearsApi } from '../../Settings/AcademicYears/AcademicYearApi';
import { AttendanceApi } from '../../Enrollment/Attendance/AttendanceApi';
import { SessionsApi } from '../../Settings/Sessions/SessionsApi';
import { billPaymentApi } from '../../BillingAndPayment/BillPaymentApi';
import { studentPaymentApi } from '../../Enrollment/Students/StudentPaymentApi';
import { studentDocumentsApi } from '../../Enrollment/Students/StudentDocumentsApi';
import { reportsApi } from '../../Reports/ReportsApi';
import { ListApi } from '../../Payroll/List/ListApi';
import { printingApi } from '../API/PrinterApi';
import { paymentsSlice } from '../../BillingAndPayment/PaymentsApi';
import { noticeboardApi } from '../../Noticeboard/NoticeboardApi';
import { AcademicMarksheetApi } from '../../Academics/MarksEntry/AcademicMarksEntryApi';
import { ClassSubjectsApi } from '../../Settings/Classes/ClassSubjectsApi';
import { SubjectsApi } from '../../Academics/Subjects/SubjectsApi';
import { EmployeeApi } from '../../Payroll/Employee/EmployeeApi';
import { AccountsApi } from '../../Accounting/AccountsApi';
import { PaygradeApi } from '../../Payroll/Paygrade/PaygradeApi';
import { PayrollSetupApi } from '../../Payroll/Setup/PayrollSetupApi';
import classReducer from '../../Settings/Classes/ClassSlice';
import studentReduce from '../../Enrollment/Students/StudentSlice';
import userAccountReduce from '../../Settings/UserAccounts/UserAccountsSlice';
import staffReduce from '../../Enrollment/Staff/StaffSlice';
import subjectsReduce from '../../Academics/Subjects/SubjectsSlice';
import paymentReduce from '../../BillingAndPayment/PaymentSlice';
import commonSlice from './Slice/CommonSlice';
import serviceStateSlice from './Slice/ServiceStateSlice';
import academicSlice from '../../Academics/AcademicSlice';
import attendanceSlice from '../../Enrollment/Attendance/AttendanceSlice';
import sessionSlice from '../../Settings/Sessions/SessionSlice';
import { DashboardApi } from '../../Dashboard/DashboardApi';
import { StaffDashboardApi } from '../../Dashboard/StaffDashboardApi';
import { AssignmentsApi } from '../../Academics/Assignments/AssignmentsApi';
import { ExaminationsApi } from '../../Academics/Examination/ExaminationsApi';
import { messagesApi } from '../../Communications/CommunicationsApi';
import { creditBalanceApi } from '../../Communications/CreaditandBalance/CreditBalanceApi';
import { authApi } from '../../ParentApp/Authentication/AuthApi';
import { ParentDashboardApi } from '../../ParentApp/ParentDashboard/ParentDashboardApi';
import { ParentPaymentApi } from '../../ParentApp/PaymentProcess/ParentPaymentApi';
import { PublicPaymentLinkApi } from '../../ParentApp/PaymentProcess/PublicPaymentLinkApi';
import { InviteApi } from '../../Authentication/InviteApi';
import { PasswordResetApi } from '../../Authentication/PasswordResetApi';
import { PublicReceiptApi } from '../../ParentApp/PublicReceipt/PublicReceiptApi';
import { SchoolInvoicePaymentLinkApi } from '../../ParentApp/PaymentProcess/SchoolInvoicePaymentLinkApi';
import { ParentInboxApi } from '../../ParentApp/Inbox/ParentInboxApi';
import { RemarksApi } from '../../Settings/Remarks/RemarksApi';
import { OutlineApi } from '../../Academics/Outline/OutlineApi';
import { BehaviorApi } from '../../StudentBehavior/BehaviourApi';
import { ShopApi } from '../../Shop/ShopApi';
import { LessonNotesApi } from '../../Academics/LessonNotes/LessonNotesApi';
import { SubjectOutlinesApi } from '../../Academics/LessonNotes/SubjectOutlinesApi';
import { StrandsApi } from '../../Academics/LessonNotes/StrandsApi';
import { StandardsApi } from '../../Academics/Standards/StandardsApi';
import { standardsProgressApi } from '../../Academics/Standards/StandardsProgressApi';
import { DiagnosticAlertsApi } from '../../Dashboard/DiagnosticAlertsApi';
import { licensingApi } from '../../Settings/Subscription/LicensingApi';
import { assessmentsApi } from '../API/AssessmentsApi';
import { feeItemApi } from '../../BillingAndPayment/FeeItemApi';
import { stagedPaymentsApi } from '../../BillingAndPayment/StagedPaymentsApi';
import assessmentsSlice from '../../Assessments/AssessmentsSlice';
import { scholarshipApi } from '../API/ScholarshipApi';
import { termActivationApi } from '../../Enrollment/TermActivation/TermActivationApi';
import { studentImportApi } from '../../Enrollment/Students/StudentImportApi';
import { payoutApi } from '../../Settings/Payments/PayoutApi';

export const store = configureStore({
  reducer: {
    [authSlice.reducerPath]: authSlice.reducer,
    [authApi.reducerPath]: authApi.reducer,

    [classesApi.reducerPath]: classesApi.reducer,
    [studentsApi.reducerPath]: studentsApi.reducer,
    [staffsApi.reducerPath]: staffsApi.reducer,
    [userAccountsApi.reducerPath]: userAccountsApi.reducer,
    [AcademicYearsApi.reducerPath]: AcademicYearsApi.reducer,
    [AttendanceApi.reducerPath]: AttendanceApi.reducer,
    [SessionsApi.reducerPath]: SessionsApi.reducer,
    [billPaymentApi.reducerPath]: billPaymentApi.reducer,
    [feeItemApi.reducerPath]: feeItemApi.reducer,
    [stagedPaymentsApi.reducerPath]: stagedPaymentsApi.reducer,
    [studentPaymentApi.reducerPath]: studentPaymentApi.reducer,
    [reportsApi.reducerPath]: reportsApi.reducer,
    [printingApi.reducerPath]: printingApi.reducer,
    [studentDocumentsApi.reducerPath]: studentDocumentsApi.reducer,
    [paymentsSlice.reducerPath]: paymentsSlice.reducer,
    [noticeboardApi.reducerPath]: noticeboardApi.reducer,
    [AcademicMarksheetApi.reducerPath]: AcademicMarksheetApi.reducer,
    [ClassSubjectsApi.reducerPath]: ClassSubjectsApi.reducer,
    [EmployeeApi.reducerPath]: EmployeeApi.reducer,
    [PayrollSetupApi.reducerPath]: PayrollSetupApi.reducer,
    [PaygradeApi.reducerPath]: PaygradeApi.reducer,
    [ListApi.reducerPath]: ListApi.reducer,
    [SubjectsApi.reducerPath]: SubjectsApi.reducer,
    [DashboardApi.reducerPath]: DashboardApi.reducer,
    [StaffDashboardApi.reducerPath]: StaffDashboardApi.reducer,
    [AssignmentsApi.reducerPath]: AssignmentsApi.reducer,
    [AccountsApi.reducerPath]: AccountsApi.reducer,
    [ExaminationsApi.reducerPath]: ExaminationsApi.reducer,
    [messagesApi.reducerPath]: messagesApi.reducer,
    [creditBalanceApi.reducerPath]: creditBalanceApi.reducer,
    [ParentDashboardApi.reducerPath]: ParentDashboardApi.reducer,
    [ParentInboxApi.reducerPath]: ParentInboxApi.reducer,
    [ParentPaymentApi.reducerPath]: ParentPaymentApi.reducer,
    [PublicPaymentLinkApi.reducerPath]: PublicPaymentLinkApi.reducer,
    [PublicReceiptApi.reducerPath]: PublicReceiptApi.reducer,
    [InviteApi.reducerPath]: InviteApi.reducer,
    [PasswordResetApi.reducerPath]: PasswordResetApi.reducer,
    [SchoolInvoicePaymentLinkApi.reducerPath]: SchoolInvoicePaymentLinkApi.reducer,
    [ShopApi.reducerPath]: ShopApi.reducer,
    [RemarksApi.reducerPath]: RemarksApi.reducer,
    [OutlineApi.reducerPath]: OutlineApi.reducer,
    [BehaviorApi.reducerPath]: BehaviorApi.reducer,
    [LessonNotesApi.reducerPath]: LessonNotesApi.reducer,
    [SubjectOutlinesApi.reducerPath]: SubjectOutlinesApi.reducer,
    [StrandsApi.reducerPath]: StrandsApi.reducer,
    [StandardsApi.reducerPath]: StandardsApi.reducer,
    [standardsProgressApi.reducerPath]: standardsProgressApi.reducer,
    [DiagnosticAlertsApi.reducerPath]: DiagnosticAlertsApi.reducer,
    [licensingApi.reducerPath]: licensingApi.reducer,
    [assessmentsApi.reducerPath]: assessmentsApi.reducer,
    [scholarshipApi.reducerPath]: scholarshipApi.reducer,
    [termActivationApi.reducerPath]: termActivationApi.reducer,
    [studentImportApi.reducerPath]: studentImportApi.reducer,
    [payoutApi.reducerPath]: payoutApi.reducer,



    class: classReducer,
    student: studentReduce,
    user: userAccountReduce,
    staff: staffReduce,
    subject: subjectsReduce,
    payment: paymentReduce,
    common: commonSlice,
    serviceState: serviceStateSlice,
    academic: academicSlice,
    session: sessionSlice,
    attendance: attendanceSlice,
    assessments: assessmentsSlice,

  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(
      authSlice.middleware,
      authApi.middleware,
      classesApi.middleware,
      studentsApi.middleware,
      staffsApi.middleware,
      userAccountsApi.middleware,
      AcademicYearsApi.middleware,
      AttendanceApi.middleware,
      SessionsApi.middleware,
      billPaymentApi.middleware,
      feeItemApi.middleware,
      stagedPaymentsApi.middleware,

      studentPaymentApi.middleware,
      studentDocumentsApi.middleware,
      reportsApi.middleware,
      printingApi.middleware,
      noticeboardApi.middleware,
      AcademicMarksheetApi.middleware,
      ClassSubjectsApi.middleware,
      SubjectsApi.middleware,
      AssignmentsApi.middleware,
      EmployeeApi.middleware,
      PaygradeApi.middleware,
      PayrollSetupApi.middleware,
      ListApi.middleware,
      DashboardApi.middleware,
      StaffDashboardApi.middleware,
      AccountsApi.middleware,
      ExaminationsApi.middleware,
      messagesApi.middleware,
      creditBalanceApi.middleware,
      ParentDashboardApi.middleware,
      ParentInboxApi.middleware,
      ParentPaymentApi.middleware,
      PublicPaymentLinkApi.middleware,
      PublicReceiptApi.middleware,
      InviteApi.middleware,
      PasswordResetApi.middleware,
      SchoolInvoicePaymentLinkApi.middleware,
      ShopApi.middleware,
      RemarksApi.middleware,
      OutlineApi.middleware,
      BehaviorApi.middleware,
      LessonNotesApi.middleware,
      SubjectOutlinesApi.middleware,
      StrandsApi.middleware,
      StandardsApi.middleware,
      standardsProgressApi.middleware,
      DiagnosticAlertsApi.middleware,
      licensingApi.middleware,
      assessmentsApi.middleware,
      scholarshipApi.middleware,
      termActivationApi.middleware,
      studentImportApi.middleware,
      payoutApi.middleware,

    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

setupListeners(store.dispatch);
